import SmartNavigator from '../generic/SmartNavigator'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import useSmartTranslation from '../generic/hooks/useSmartTranslation/useSmartTranslation'
import GenericDashboardIframe from '../dashboard/GenericDashboardIframe'

const MainDashboardCustomized = () => {
  const [config] = useFrontEndConfig()

  const { t_ } = useSmartTranslation()

  if (config === null) return null

  const componentsInfo = [
    {
      title: t_('Customized'),
      component: <GenericDashboardIframe url={config.dashboardCustom} defaultDashboardUrl='/dashboards/d/demnurgwc4l4wf' kioskMode={false} />,
      permissionCode: 'DASHBOARD_CUSTOMIZED'
    }
  ]

  return (
    <SmartNavigator componentsInfo={componentsInfo} />
  )
}

export default MainDashboardCustomized
